import { Injectable } from '@angular/core';

import { NativeAppService, WindowRef } from '@frontend/vanilla/core';

/**
 * @whatItDoes Provides functionality related to communication with native apps
 *
 * @description Provides communication bridge with native app by adding iframe element to the document.body
 *
 */
@Injectable({
    providedIn: 'root',
})
export class NativeEventApiService {
    private count: number = 0;

    constructor(
        private nativeApplication: NativeAppService,
        private windowRef: WindowRef,
    ) {}

    raiseEvent(eventInfo: string) {
        if (this.nativeApplication.isNative) {
            this.count++;
            const id = 'NativeApi_iframe_' + this.count;

            const frame = document.createElement('iframe');
            frame.id = id;
            frame.src = `bwinex://${eventInfo}`;
            frame.style.display = 'none';

            this.windowRef.nativeWindow.document.body.appendChild(frame);
            return id;
        }
        return;
    }

    clearEvent(id: string) {
        if (this.nativeApplication.isNative && id !== null) {
            this.windowRef.nativeWindow.document.getElementById(id)!.remove();
        }
    }

    targetEvent(event: string, scheme: string = 'bwinex://') {
        if (this.nativeApplication.isNative) {
            const iframe = document.createElement('iframe');
            iframe.src = scheme + event;

            document.documentElement.appendChild(iframe);
            iframe.parentNode!.removeChild(iframe);
        }
    }
}
